import { getAttr, getClasses, getComponent, getID } from "./../../common/utils";

Link.version = 1000;
Object.defineProperty(Link, 'name', {
  writable: true,
  value: 'Link'
});

export function Link(props:any) {

    let componentClasses = getClasses(props.data);
    let componentID = getID(props.data);
    let componentHref = getAttr(props.data, "href");
    let componentTitle = getAttr(props.data, "title");

    let Tag:any = '';
    if( props.data.tagName ) {
        Tag = props.data.tagName;
    }

    let childText:any = "";
    if( props.data.components ) {
        childText = getComponent(props.data.components);
    }

    let out =
            <a id={componentID} className={componentClasses} href={componentHref} title={componentTitle} target="_self">
                {childText}
            </a>

    if( Tag ) {
        out =
            <Tag id={componentID} className={componentClasses}>
                {childText}
            </Tag>;
    }

    return (
        <>
            {out}
        </>
    )

}
